<template>
  <div class="linkageProgramming">
    <box ref="box"></box>
    <el-card shadow="never" class="singleQuery" ref="card">
      <div class="titleBox">
        <div class="title">{{ $t('singleProgramming') }}</div>
        <el-button class="btn1" type="primary" @click.prevent="_setProgram()" :loading="setting">{{ $t('set') }}</el-button>
        <el-button class="btn2" type="primary" :loading="singleSearching"
                   @click="_getProgram()">{{ $t('queryButton') }}
        </el-button>
      </div>
      <div class="single">
        <el-row>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('panelNumber') }}</div>
            <el-input-number v-model="searchForm.controllerNo" :min="0" :max="254"></el-input-number>
          </el-col>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('loopNo') }}</div>
            <el-input-number v-model="searchForm.loopNo" :min="0" :max="254"></el-input-number>
          </el-col>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('codeNo') }}</div>
            <el-input-number v-model="searchForm.codeNo" :min="0" :max="254"></el-input-number>
          </el-col>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('startupTime') }}</div>
            <el-input v-model="startupTime">
              <template slot="append">s</template>
            </el-input>
          </el-col>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('actionTime') }}</div>
            <el-input v-model="actionTime">
              <template slot="append">s</template>
            </el-input>
          </el-col>
          <el-col :span="4" class="column">
            <div class="name">{{ $t('logicalExpression') }}</div>
            <el-input v-model="logic"></el-input>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card shadow="never" class="allQuery" ref="allQuery" :style="style">
      <div class="title">
        {{ $t('totalLinkageProgramming') }}
        <span class="title-btn" v-show="!tableShow" @click="handleRefresh">
          <!-- <el-button type="primary">刷新</el-button> -->
        </span>
      </div>
      <div class="btnBox" v-show="tableShow">
        <el-button class="btn1" icon="iconfont iconshangchuan1" @click="handleReadFile" :loading="uploading">{{ $t('panelUpload') }}
        </el-button>
        <!--  注释信息-下发文件至控制器      -->
        <el-upload
            class="btn5"
            action="no"
            :show-file-list=false
            :http-request="handleWriteFile">
          <el-button type="primary" :loading="writing">{{ $t('fileDownload') }}</el-button>
        </el-upload>
        <el-button class="btn4" type="primary" @click="_setAll" :loading="configing">{{ $t('configDownload') }}</el-button>
        <el-button class="btn4" style="width: 90px" type="primary" @click="_exportProgram" :loading="exporting">{{ $t('export') }}</el-button>
        <i class="el-icon-delete btn2" @click="deleteAll()"></i>
      </div>
      <i v-show="tableShow" class="el-icon-plus addBtn" @click="addRow()"></i>
      <div class="linkageBottom" ref="linkageBottom">
        <div v-show="tableShow" class="tableBox">
          <el-table ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching"
                    :row-class-name="tableRowClassName" @cell-click="tabClick" v-clickoutside="handleClose">
            <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
            <el-table-column prop="controllerNo" :label="$t('panelNumber')" align="center">
              <template slot-scope="scope">
                <span v-if="isAdd">
                  <el-input style="width: 100px" v-model="scope.row.controllerNo" maxlength="20" size="mini"/>
                </span>
                <span v-else-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.controllerNo" disabled maxlength="20" size="mini"/>
                </span>
                <span v-else>{{ scope.row.controllerNo }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="loopNo" :label="$t('loopNumber')" align="center">
              <template slot-scope="scope">
                <span v-if="isAdd">
                  <el-input style="width: 100px" v-model="scope.row.loopNo" maxlength="20" size="mini"/>
                </span>
                <span v-else-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.loopNo" disabled maxlength="20" size="mini"/>
                </span>
                <span v-else>{{ scope.row.loopNo }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="codeNo" :label="$t('codeNo')" align="center">
              <template slot-scope="scope">
                <span v-if="isAdd">
                  <el-input style="width: 100px" v-model="scope.row.codeNo" maxlength="20" size="mini"/>
                </span>
                <span v-else-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.codeNo" disabled maxlength="20" size="mini"/>
                </span>
                <span v-else>{{ scope.row.codeNo }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="startupTime" :label="$t('startupTime')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.startupTime" maxlength="20" size="mini"/>
                </span>
                <span v-else>{{ scope.row.startupTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="actionTime" :label="$t('actionTime')" width="120px" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 100px" v-model="scope.row.actionTime" maxlength="20" size="mini"/>
                </span>
                <span v-else>{{ scope.row.actionTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="logic" width="300px" :label="$t('logicalExpression')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.index === tabClickIndex">
                  <el-input style="width: 120px" v-model="scope.row.logic" maxlength="20" size="mini"/>
                  <i style="color: #2DC555;padding: 0 10px;margin-left: 10px;cursor: pointer"
                     @click.stop="onConfirm(tabClickIndex)" class="iconfont icondui" :title="$t('save')"></i>
                  <i style="color: #FB6041;padding: 0 10px;cursor: pointer" @click.stop="onCancel(tabClickIndex)"
                     class="iconfont iconcuo" :title="$t('cancel')"></i>
                  <i class="btn el-icon-delete icon-danger" style="cursor: pointer" @click.stop="remove(scope.row, tabClickIndex)"
                     :title="$t('delete')"></i>
                </span>
                <span v-else>{{ scope.row.logic }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination ref="basePagination" class="pagination" @size-change="handleSizeChange" background
                         @current-change="handleCurrentChange"
                         :page-sizes="pageSizes"
                         :page-size.sync="pageSize"
                         :current-page.sync="pageNumber"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
        <div v-show="!tableShow" class="uploadBox" :style="{height: `${this.bottomHeight}px`}">
          <el-image
              class="image"
              :src="direction === 1 ? up : down"
              :fit="fit">
          </el-image>
          <div class="progress">
            <div class="name" v-show="direction === 1">{{ $t('sendToControllerProgress') }}</div>
            <div class="name" v-show="direction === 2">{{ $t('controllerUploadProgress') }}</div>
            <div class="value" v-show="statusRefresh == 1">{{ current }}</div>
            <div class="value" v-show="statusRefresh == 0">{{$t('success')}}</div>
            <div class="fail" v-show="statusRefresh == 2">{{$t('fail')}}</div>
          </div>
          <el-button v-show="isShowCon" @click="handleConfirm">{{$t('confirm')}}</el-button>
          <el-button v-show="!isShowCon" @click="handleCancel">{{$t('cancel')}}</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
import Box from "@/components/Box";
import up from 'assets/img/box/up.png'
import down from 'assets/img/box/down.png'
import Status from "components/Status";
import {
  getProgram,
  getSchedule,
  readProgramFile,
  setProgramAll,
  setProgram,
  writeProgramFile,
  deleteProgramAll,
  getProgramList, updateProgram, removeProgram, exportProgram, getRefresh, compelte, cancel
} from "api/query";
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数，则调用那个函数，
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  update() {},
  unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
export default {
  name: "linkageProgramming",
  mixins: [BasePage, Status],
  components: {
    Box
  },
  /**在vue里注册构造的函数**/
  directives: { clickoutside },
  data() {
    return {
      searchForm: {
        loopNo: 1,
        controllerNo: 1,
        codeNo: 1
      },
      bottomHeight: null,
      style: null,
      fit: 'contain',
      tableShow: true,
      current: 0,
      rowsLinkage: [
        {
          machineNo: 1,
          circuitBoardNumber: 2,
          codeNo: 3
        }
      ],
      clicked: true,
      tabClickIndex: null,
      tabClickLabel: '',
      startupTime: '',
      actionTime: '',
      logic: '',
      searching: false,
      singleSearching: false,
      isShowCon: false,
      type: 1,
      direction: '',
      configing: false,
      uploading: false,
      setting: false,
      exporting: false,
      writing: false,
      statusRefresh:1,
      isAdd: false,
      up:up,
      down:down
    }
  },
  mounted() {
    this.calcHeight()
    this._getSchedule()
    this.$nextTick(() => {
      document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) {
          this.tabClickIndex = null
          this.tabClickLabel = ''
        }
      })
    })
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm._getSchedule()
    })
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  methods: {
    handleClose () { // 点击除了页面其他地方关闭车型选择
      this.tabClickIndex = null
      this.tabClickLabel = ''
    },
    _deleteSchedule() {
      compelte({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 2
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.tableShow = true
          this._getDescrList()
        }
      })
    },
    addRow() {
      this.isAdd = true
      this.rows.unshift({
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: '',
        loopNo: '',
        codeNo: '',
        startupTime: '',
        actionTime: '',
        logic: ''
      })
    },
    _getSchedule() {
      // 获取当前进度
      getSchedule({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 2
      }).then((res) => {
        if (res.code === 1) {
          if (res.data == null) {
            this.tableShow = true
            this.getRows()
          } else {
            this.statusRefresh = res.data.state
            if (res.data.current) {
              this.current = res.data.current / res.data.total * 100
              this.current = this.current.toFixed(2)
            } else {
              this.current = 0
            }
            if (res.data.current === 0 && res.data.total === 0) {
              this.current = 1
            }
            const _this = this
            this.timer = setInterval(() => {
              if (res.data.state === 0 || res.data.state === 2) {
              this.isShowCon = true
              clearInterval(this.timer)
              } else if (res.data.state === 1) {
                this.isShowCon = false
                _this.handleRefresh()
              }
          }, 2000)
            this.direction = res.data.direction
            this.tableShow = false
          }
        }
      })
    },
    calcHeight() {
      setTimeout(() => {
        this.boxHeight = this.$refs.box.$el.clientHeight
        this.bottomHeight = (this.boxHeight + this.$refs.card.$el.clientHeight + 14) + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    onConfirm(tabClickIndex) {
      if (this.rows[tabClickIndex].controllerNo === '') {
        this.$message.warning('请填写完成信息，再保存')
        return
      }
      if (this.rows[tabClickIndex].loopNo === '') {
        this.$message.warning('请填写完成信息，再保存')
        return
      }
      if (this.rows[tabClickIndex].codeNo === '') {
        this.$message.warning('请填写完成信息，再保存')
        return
      }
      if (this.rows[tabClickIndex].startupTime === '') {
        this.$message.warning('请填写完成信息，再保存')
        return
      }
      if (this.rows[tabClickIndex].actionTime === '') {
        this.$message.info('请填写数据再保存')
        return
      }
      if (this.rows[tabClickIndex].logic === '') {
        this.$message.info('请填写数据再保存')
        return
      }
      updateProgram({...this.rows[tabClickIndex]}).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.getRows()
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
      this.tabClickIndex = null
      this.tabClickLabel = ''
      this.isAdd = false
    },
    onCancel(tabClickIndex) {
      this.$message.info('取消编辑')
      this.getRows()
      this.tabClickIndex = null
      this.tabClickLabel = ''
    },
    _setProgram() {
      this.setting = true
      this.show()
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo,
        codeNo: this.searchForm.codeNo,
        startupTime: this.startupTime,
        actionTime: this.actionTime,
        logic: this.logic
      }
      setProgram(searchParams).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.setting = false
        }
      }).catch(() => {
        this.failed()
        this.setting = false
      })
    },
    // 批量查询
    getRows() {
      this.searching = true
      // 注释信息-批量查询(数据库)
      getProgramList({
        controllerPsn: this.controllInfo.controllerPsn,
        pageNum: this.pageNumber,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.code === 1) {
          this.rows = res.data
          this.total = res.total
        }
        this.searching = false
        //this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.searching = false
      })
    },
    // tabClick row 当前行 column 当前列
    tabClick(row, column, cell, event) {
      this.tabClickIndex = row.index
      this.tabClickLabel = column.label
      console.log('tabClick', this.tabClickIndex, row.actionTime, row.logicalExpression)
    },
    tableRowClassName({row, rowIndex}) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    remove(row, tabClickIndex) {
      this.$confirm(`确定删除id为：${row.id}的记录吗?`).then(() => {
        this.rows.splice(tabClickIndex, 1)
        if (row.controllerNo === '') {
          this.$message.warning('数据不存在，无法删除')
          return
        }
        let params = {
          controllerNo: row.controllerNo,
          loopNo: row.loopNo,
          codeNo: row.codeNo,
          controllerPsn: row.controllerPsn
        }
        removeProgram(params).then((res) => {
          if (res.code === 1) {
            this.getRows()
            this.$message.success(res.message)
            this.tabClickIndex = null
          }
        })
      })
    },
    _getProgram() {
      this.singleSearching = true
      this.show()
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn,
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo,
        codeNo: this.searchForm.codeNo
      }
      getProgram(searchParams).then((res) => {
        if (res.code === 1) {
          this.singleSearching = false
          this.startupTime = res.data.startupTime
          this.actionTime = res.data.actionTime
          this.logic = res.data.logic
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
        this.singleSearching = false
      })
    },
    // 从控制器上传文件，你要显示出来，先调进度接口，如果没完成就继续显示当前进度，完成后调用批量查询
    handleReadFile() {
      this.uploading = true
      this.show()
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn
      }
      readProgramFile(searchParams).then((res) => {
        if (res.code === 1) {
          // 接口返回成功即可显示对勾
          this._getSchedule()
          this.success(res.message ? res.message : '操作成功')
          this.uploading = false
        }
      }).catch(() => {
        this.uploading = false
        this.failed()
      })
    },
    _setAll() {
      this.show()
      this.configing = true
      let searchParams = {
        controllerPsn: this.controllInfo.controllerPsn
      }
      setProgramAll(searchParams).then((res) => {
        if (res.code === 1) {
          // 接口返回成功即可显示对勾
          this.success(res.message ? res.message : '操作成功')
          this.configing = false
          this.tableShow = !this.tableShow
          // 获取当前进度
          this._getSchedule()
          // getSchedule({
          //   controllerPsn: this.controllInfo.controllerPsn,
          //   type: 2
          // }).then((res) => {
          //   if (res.code === 1) {
          //     this.current = res.data.current
          //     if (this.current === res.data.total) {
          //       // 调用批量查询
          //       this.getRows()
          //     }
          //   }
          // })
        }
      }).catch(() => {
        this.failed()
        this.configing = false
      })
    },
    _exportProgram() {
      this.exporting = true
      this.show()
      let params = {
        controllerPsn: this.controllInfo.controllerPsn
      }
      const language = this.$store.state.language
      let metas = [
        {
          "label": "控制器号",
          "prop": "controllerNo"
        },
        {
          "label": "回路号",
          "prop": "loopNo"
        },
        {
          "label": "部件号",
          "prop": "codeNo"
        },
        {
          "label": "启动时间",
          "prop": "startupTime"
        },
        {
          "label": "动作时间",
          "prop": "actionTime"
        },
        {
          "label": "逻辑表达式",
          "prop": "logic"
        }]
      let metasEnglish = [
        {
          "label": "Panel number",
          "prop": "controllerNo"
        },
        {
          "label": "Loop number",
          "prop": "loopNo"
        },
        {
          "label": "Component number",
          "prop": "codeNo"
        },
        {
          "label": "startup time",
          "prop": "startupTime"
        },
        {
          "label": "action time",
          "prop": "actionTime"
        },
        {
          "label": "Logical expression",
          "prop": "logic"
        }]
      let searchParam = {}
      if (language === 'chinese') {
        searchParam = {
          "params": params,
          "metas": metas
        }
      } else {
        searchParam = {
          "params": params,
          "metas": metasEnglish
        }
      }
      exportProgram(searchParam).then((res) => {
        if (res.code === 1) {
          this.exporting = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
        this.exporting = false
      })
    },
    deleteAll() {
      this.$confirm('确定删除全部记录吗?').then(() => {
        deleteProgramAll({controllerPsn: this.controllInfo.controllerPsn}).then((res) => {
          if (res.code === 1) {
            this._getSchedule()
            this.$message.success(res.message)
          }
        })
      })
    },
    handleWriteFile(val) {
      this.show()
      this.writing = true
      let params = {
        file: val.file,
        controllerPsn: this.controllInfo.controllerPsn
      }
      writeProgramFile(params).then((res) => {
        if (res.code === 1) {
          this.success(res.message ? res.message : '操作成功')
          this.writing = false
          this.tableShow = !this.tableShow
          this._getSchedule()
          // 获取当前进度
          // getSchedule({
          //   controllerPsn: this.controllInfo.controllerPsn,
          //   type: 2
          // }).then((res) => {
          //   if (res.code === 1) {
          //     this.current = res.data.current
          //     if (this.current === res.data.total) {
          //       // 调用批量查询
          //       this.getRows()
          //     }
          //   }
          // })
        }
      }).catch(() => {
        this.failed()
        this.writing = false
      })
    },
    //刷新
    handleRefresh() {
      getRefresh({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 2
      }).then((res) => {
        if (res.code === 1) {
          //this.$message.success('操作成功')
          this.statusRefresh = res.data.state
          if (res.data.state === 0 || res.data.state === 2) {
            clearInterval(this.timer)
            //this.current = 100
            this.isShowCon = true
          }
          const data = res.data
          if (data) {
            this.current = data.current / data.total * 100
            this.current = this.current.toFixed(2)
            this.direction = res.data.direction
            if (!data.current) {
            this.current = 0
            }
             if (data.current === 0 && res.data.total === 0) {
              this.current = 1
            }
          }
        }
      })
    },
    //确定
    handleConfirm() {
      compelte({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 2
      }).then((res) => {
        if (res.code === 1) {
          this.tableShow = true
          this.isShowCon = false
          this.$message.success('操作成功')
          this.getRows()
        }
      })
    },
    //取消
    handleCancel() {
      cancel({
        controllerPsn: this.controllInfo.controllerPsn,
        type: 2
      }).then((res) => {
        if (res.code === 1) {
          this.tableShow = true
          this.isShowCon = false
          this.$message.success('操作成功')
          this.getRows()
          clearInterval(this.timer)
        }
      })
    }
  },
   beforeDestroy(){
    if (this.timer) {
      clearInterval(this.timer)
    }
    },
  watch:{
     $route:{
      handler(val,oldval){
          clearInterval(this.timer)
      },
      deep: true
    },
    statusRefresh(val){
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.linkageProgramming {
  .singleQuery {
    margin-bottom: 10px;

    .titleBox {
      .title {
        display: inline-block;
        font-weight: bold;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold;
        line-height: 30px;
        color: #2F4E68FF;
        margin-bottom: 10px;
      }

      .btn1, .btn2 {
        float: right;
        width: 90px;
      }

      .btn2 {
        margin-right: 20px;
      }
    }

    .single {
      text-align: center;

      .column {
        .name {
          padding: 6px 0;
          background-color: #f5f7fa;
          margin-bottom: 5px;
          color: #646464;
        }
      }
    }
  }

  .allQuery {
    position: relative;
    margin-bottom: 10px;

    .title {
      font-weight: bold;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold;
      line-height: 30px;
      color: #2F4E68FF;

      .title-btn {
        cursor: pointer;
        color: #00BEFF;
      }
    }

    .btnBox {
      .iconshangchuan1, .btn1 {
        color: #00BEFF;
      }

      .iconshangchuan1 {
        font-size: 18px;
      }

      .btn1 {
        border: none;
        padding-left: 0px;
      }

      .btn2, .btn3, .btn4, .btn5 {
        float: right;
      }
      .btn2, .btn3 {
        color: #00BEFF;
        margin-top: 3px;
        font-size: 20px;
        margin-left: 20px;
        cursor: pointer;
      }

      .btn5 {
        margin-left: 20px;
      }

      .btn4 {
        margin-left: 20px;
      }
    }

    .addBtn {
      color: #00BEFF;
      padding: 0 10px 10px 10px;
      font-weight: bold;

      &:hover {
        cursor: pointer;
      }
    }

    .linkageBottom {
      text-align: center;
      height: 100%;
      box-sizing: border-box;

      .tableBox {
        .add {
          display: inline-block;
          width: 10px;
          height: 10px;
          position: absolute;
          top: 19%;
          left: 2%;
          z-index: 1000;
          font-size: 16px;
          font-weight: bold;
          color: #00BEFF;
        }

        .btn {
          font-size: 16px;
          padding: 0 5px;
        }

        .icon-danger {
          color: #F56C6C;
        }
      }

      .uploadBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .image {
          width: 200px;
          height: 180px;
        }

        .progress {
          color: #959595;
          height: 30px;

          .name {
            display: inline-block;
            padding: 5px 0;
          }

          .value {
            padding-left: 10px;
            display: inline-block;
            line-height: 30px;
            height: 30px;
            color: #00BEFF;
          }
          .fail{
             padding-left: 10px;
            display: inline-block;
            line-height: 30px;
            height: 30px;
            color: red;
          }
        }
      }
    }
  }
}
</style>
